
/**
 * NOTE: DEV-1776. Now this component the same with "ExpertTasks", but then logic,
 * columns and design of tables can change.
 */

import { Component, Vue } from "vue-property-decorator";
import { SMCases, SMTasksServices } from "@/store";
import { TTask_Table } from "@/models/tasks";

import {
  TASK_TABS_SERVICE_CANDIDATE,
  TASK_TABS_NAME_CANDIDATE,
  EMPLOYER_TASKS_TAB,
} from "@/constants/tasks";
import { DEPENDANT_INSIDE_SERVICE_TYPE } from "@/constants/services";

const VALUE_NAME = "name";
const VALUE_STEP = "step";
const VALUE_START_DATE = "startDate";
const VALUE_END_DATE = "endDate";
const VALUE_ASSIGNED_TO = "assignedTo";
const VALUE_STATUS = "status";

@Component({
  components: {
    ToDoTasksTableTabs: () => import("@/modules/Tasks/ToDoTasksTable/ToDoTasksTableTabs.vue"),
  },
})
export default class CandidateTasks extends Vue {
  get tabValues(): string[] {
    if (SMCases.caseType !== DEPENDANT_INSIDE_SERVICE_TYPE) return TASK_TABS_SERVICE_CANDIDATE;

    return TASK_TABS_SERVICE_CANDIDATE.filter((name) => name !== EMPLOYER_TASKS_TAB);
  }

  get tabNames() {
    if (SMCases.caseType !== DEPENDANT_INSIDE_SERVICE_TYPE) return TASK_TABS_NAME_CANDIDATE;

    return Object.keys(TASK_TABS_NAME_CANDIDATE).reduce((acc, key) => {
      if (key === EMPLOYER_TASKS_TAB) return acc;

      Object.assign(acc, {
        [key]: TASK_TABS_NAME_CANDIDATE[key],
      });

      return acc;
    }, {});
  }

  get tableProps() {
    const {
      headers,
      tabValues,
      tabNames,
      mainItems,
      mainItemsArchived,
      sideItems,
      sideItemsArchived,
    } = this;

    return {
      headers,
      tabValues,
      tabNames,
      mainItems,
      mainItemsInactive: mainItemsArchived,
      sideItems,
      sideItemsInactive: sideItemsArchived,
      countSideItemsInactive: false,
      showActions: true,
    };
  }

  get mainItems() {
    return SMTasksServices.candidateTasksToDo;
  }

  get mainItemsArchived() {
    return SMTasksServices.candidateTasksArchived;
  }

  get sideItems() {
    return SMTasksServices.employerTasksToDo;
  }

  get sideItemsArchived() {
    return SMTasksServices.employerTasksArchived;
  }

  get loading() {
    return SMTasksServices.loading;
  }

  get caseId(): number {
    return Number(this.$route.params.id);
  }

  async getTableTasks() {
    await SMTasksServices.getTableTasksToDo(this.caseId);

    await SMTasksServices.getTableTasksArchived(this.caseId);
  }

  async created() {
    await this.getTableTasks();
  }

  headers = [
    {
      text: this.$t("table.headers.name"),
      value: VALUE_NAME,
    },
    {
      text: this.$t("table.headers.step"),
      value: VALUE_STEP,
      filterable: true,
    },
    {
      text: this.$t("table.headers.startDate"),
      value: VALUE_START_DATE,
      sortable: true,
      sortBy: "date",
    },
    {
      text: this.$t("table.headers.endDate"),
      value: VALUE_END_DATE,
      sortable: true,
      sortBy: "date",
    },
    {
      text: this.$t("table.headers.assignedTo"),
      value: VALUE_ASSIGNED_TO,
      filterable: true,
    },
    {
      text: this.$t("table.headers.status"),
      value: VALUE_STATUS,
    },
  ];

  navigateTask(item: TTask_Table) {
    const { id, status } = item;

    this.$router.push({
      path: `/cases/tasks/${id}`,
      params: { status },
    });
  }

  async deleteTask(id: number) {
    await SMTasksServices.archiveTableTask(id);

    await this.getTableTasks();
  }
}
